import PropTypes from 'prop-types';
import { accountTypeLabel, bankName } from '@/lib';
import { Button, Spinner } from '@/ui';
import './Perfil.css';

function lastFour(accountNumber) {
  const digits = String(accountNumber || '').replace(/\D/g, '');
  if (!digits) return '····';
  return `···· ${digits.slice(-4)}`;
}

export default function PerfilView({
  name,
  email,
  accounts = [],
  failed = false,
  pending = false,
  readable = true,
  onAgregar,
  onEditar,
  onLogout,
}) {
  return (
    <div className="pf">
      <header className="pf-head">
        <h1 className="pf-name">{name}</h1>
        <span className="pf-status">Activa</span>
        {email ? <p className="pf-email">{email}</p> : null}
      </header>

      <section
        className="pf-bank"
        aria-labelledby="pf-bank-title"
        aria-busy={pending}
      >
        <h2 id="pf-bank-title" className="pf-bank__title">
          Cuenta para liquidaciones
        </h2>
        <p className="pf-bank__sub">
          Se usa al cotizar. No se pide de nuevo en cada solicitud.
        </p>
        {!readable ? (
          <p className="pf-bank__empty">
            Tu usuario no tiene acceso a la cuenta para liquidaciones.
          </p>
        ) : pending ? (
          <div className="pf-bank__loading">
            <Spinner aria-label="Cargando cuentas bancarias" />
            <p className="pf-bank__empty">
              Estamos buscando tu cuenta para liquidaciones.
            </p>
          </div>
        ) : accounts.length === 0 ? (
          <p className="pf-bank__empty">
            {failed
              ? 'No se pudieron cargar las cuentas bancarias.'
              : 'Aún no has registrado una cuenta para liquidaciones.'}
          </p>
        ) : (
          accounts.map((account) => (
            <div key={account.bankAccountId} className="pf-account">
              <div className="pf-account__bank">
                {bankName(account.bankCode)}
                {account.isDefault ? (
                  <span className="pf-principal">Principal</span>
                ) : null}
              </div>
              <div className="pf-account__pan">
                {lastFour(account.accountNumber)}
              </div>
              <div className="pf-account__meta">
                {accountTypeLabel(account.accountType)} · {account.holderName}
              </div>
              {onEditar ? (
                <Button
                  variant="ghost"
                  size="sm"
                  className="pf-account__edit"
                  onClick={() => onEditar(account)}
                >
                  Editar
                </Button>
              ) : null}
            </div>
          ))
        )}
        {onAgregar &&
        accounts.length === 0 &&
        !failed &&
        !pending &&
        readable ? (
          <Button variant="seal" size="md" onClick={onAgregar}>
            Agregar cuenta
          </Button>
        ) : null}
      </section>

      {onLogout ? (
        <footer className="pf-foot">
          <Button variant="ghost" size="md" onClick={onLogout}>
            Cerrar sesión
          </Button>
        </footer>
      ) : null}
    </div>
  );
}

PerfilView.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string,
  accounts: PropTypes.arrayOf(
    PropTypes.shape({
      bankAccountId: PropTypes.string.isRequired,
      bankCode: PropTypes.string,
      accountType: PropTypes.string,
      holderName: PropTypes.string,
      accountNumber: PropTypes.string,
      isDefault: PropTypes.bool,
    }),
  ),
  failed: PropTypes.bool,
  pending: PropTypes.bool,
  readable: PropTypes.bool,
  onAgregar: PropTypes.func,
  onEditar: PropTypes.func,
  onLogout: PropTypes.func,
};
